"use strict";

define('rs/models/proposal.sp',['./abstract', './proposal', 'rs/errors', 'rs/cf.convert', 'moment'], function (Abstract, Proposal, Errors, CFConvert, moment) {
  var SPProposal = Abstract.extend({
    properties: ["proposalid", "proposalnumber", "proposalstatus", "projectbegindate", "projectenddate", "projecttitle", "leadfname", "leadlname", "leadpipid"],
    toProposal: function toProposal() {
      return Proposal.model({
        id: this.getProposalid(),
        number: this.getProposalnumber(),
        status: this.getProposalstatus(),
        beginDate: new Date(this.getProjectbegindate()).getTime(),
        endDate: new Date(this.getProjectenddate()).getTime(),
        title: this.getProjecttitle(),
        leadFirstName: this.getLeadfname(),
        leadLastName: this.getLeadlname(),
        leadPersonId: this.getLeadpipid()
      });
    }
  }, {
    rootUrl: '/sp/model/cayuse/',
    requestAll: function requestAll(legacyPersonIds) {
      if (!_.isArray(legacyPersonIds)) {
        legacyPersonIds = _.toArray(arguments);
      }
      if (_.isEmpty(legacyPersonIds)) {
        return Promise.resolve([]);
      }
      var params = {
        pids: _.map(legacyPersonIds, function (personId) {
          return String(personId);
        })
      };
      var data = {
        method: 'ExecIntegrationMethod',
        theMethod: 'getProposalsByPid',
        theParams: JSON.stringify(params)
      };
      function ignoreError(e) {
        if (!window.production && e instanceof Errors.HTTPError && e.getCode() == 'http-404') {
          console.log('Ignoring failed API call to SP');
          return true;
        }
        return false;
      }
      ;
      return this.get('cayuseIntegration.cfc', data, {
        dataType: 'json'
      }).then(function (resp) {
        return SPProposal.models(CFConvert.convertResponse(resp));
      }).caught(ignoreError, function (data) {
        return [];
      });
    },
    isValidResponse: function isValidResponse(resp) {
      return !!resp.DATA;
    },
    getResponseDefaults: function getResponseDefaults() {
      return {
        valid: false
      };
    },
    getResponseSuccessPayload: function getResponseSuccessPayload(resp) {
      return resp;
    },
    getResponseFailPayload: function getResponseFailPayload(resp) {
      resp.error = resp.USERMSG;
      return Proposal.getResponseFailPayload(resp);
    }
  });
  return SPProposal;
});

